




import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { FetchData, Toast } from "../../customHooks/customHooks";
import {  CREATE_CALL_URl, CREATE_OPERATING_URl, CREATE_PRODUCT_URl, DELETE_CALL_URl, DELETE_OPERATING_URl, DELETE_PRODUCT_URl, GET_Calls_HISTORY_URl, GET_Calls_URl, GET_OPERATING_URl, UPDATE_CALL_URl, UPDATE_OPERATING_URl, UPDATE_PRODUCT_URl, } from "../../api";

// -- Async Thunk to Get User Profile --
export const GetOperatingSystem = createAsyncThunk('getGetOperatingSystem', async (body, { rejectWithValue }) => {

    try {
        await new Promise(resolve => setTimeout(resolve, 400));
        const response = await FetchData(GET_OPERATING_URl, body);

        if (!response) throw new Error("No response received");

        if (response.status === 200) {
            
            let { data } = response.data
            return { status: 200, data } // ✅ Return the actual user profile data
        } else if (response.status === 401) {
            return rejectWithValue("Unauthorized");
        } else {
            return rejectWithValue("Failed to fetch user profile");
        }
    } catch (err) {
        console.log("Error fetching user profile:", err);
        return rejectWithValue(err.message || "Something went wrong");
    }
});

// -- Slice --
const GetAllOperatingSystemSlice = createSlice({
    name: 'Operating System',
    initialState: {
        OperatingSystem: [],
        loading: false,
        error: null
    },
    extraReducers: (builder) => {
        builder
            .addCase(GetOperatingSystem.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(GetOperatingSystem.fulfilled, (state, action) => {
                state.OperatingSystem = action.payload; // ✅ Store fetched profile
                state.loading = false;
            })
            .addCase(GetOperatingSystem.rejected, (state, action) => {
                state.error = action.payload || action.error.message;
                state.loading = false;
            });
    }
});


const OperatingSystemSlice = createSlice({
    name: 'Operating System  Details ',
    initialState: {
        OperatingSystemDetail: ''
    },
    reducers: {
        setOperatingSystemDetail: (state, action) => {
            state.OperatingSystemDetail = action.payload;
        }
    }
});

export const CreateOperatingSystem = createAsyncThunk('CreateoperatingSystem', async (body, { rejectWithValue }) => {

    try {
        const response = await FetchData(CREATE_OPERATING_URl, body);

        if (!response) throw new Error("No response received");

        if (response.status === 200) {
            Toast('success', response?.data?.apiStatus?.statusMessage)
            return 'ok'
        } else if (response.status === 401) {
            return rejectWithValue("Unauthorized");
        } else {
            return rejectWithValue("Failed to fetch user profile");
        }
    } catch (err) {
        console.log("Error fetching user profile:", err);
        return rejectWithValue(err.message || "Something went wrong");
    }
});

export const UpdateOperatingSystem = createAsyncThunk('updateoperatingSystem', async (body, { rejectWithValue }) => {

    try {
        const response = await FetchData(UPDATE_OPERATING_URl, body);

        if (!response) throw new Error("No response received");

        if (response.status === 200) {
            Toast('success', response?.data?.apiStatus?.statusMessage)

            return 'ok'
        } else if (response.status === 401) {
            return rejectWithValue("Unauthorized");
        } else {
            return rejectWithValue("Failed to fetch user profile");
        }
    } catch (err) {
        console.log("Error fetching user profile:", err);
        return rejectWithValue(err.message || "Something went wrong");
    }
});

export const DeleteOperatingSystem = createAsyncThunk('deletoperatingSystem', async (id, { rejectWithValue }) => {

    try {
        const response = await FetchData(DELETE_OPERATING_URl, { operatingSystemMasterID: id });

        if (!response) throw new Error("No response received");

        if (response.status === 200) {
            Toast('success', response?.data?.apiStatus?.statusMessage)

            return 'ok'
        } else if (response.status === 401) {
            return rejectWithValue("Unauthorized");
        } else {
            return rejectWithValue("Failed to fetch user profile");
        }
    } catch (err) {
        console.log("Error fetching user profile:", err);
        return rejectWithValue(err.message || "Something went wrong");
    }
});





export const {setOperatingSystemDetail} = OperatingSystemSlice.actions
export {
    GetAllOperatingSystemSlice,
    OperatingSystemSlice,
};

